module.exports = __webpack_public_path__ + "img/hr-tree-03-f-leaves.2f2f2833.png";